module.exports = __webpack_public_path__ + "static/img/znsj_p4.a612436.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/solution/znsj_p4.png
// module id = elxm
// module chunks = 19